import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginBottom: theme.spacing(12),
    padding: theme.spacing(0, 1),
  },
  footerWrapper: {
    padding: '32px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  customFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
  container: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  formWidth: { width: '70%' },
  activityLogWidth: { width: '30%' },
  hideActivityLog: {
    display: 'block',
  },
  combinedFormRoot: {
    padding: theme.spacing(4),
    marginBottom: '58px',
  },
  footerWrapperButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
}))
